import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Note } from '@rocksoft/mdm-sdk-v2';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { NotesStoreActions } from './notes-store';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../../../stores/router';

@Injectable()
export class NoteResolver {
  constructor(
    private readonly noteStore: Store<Note>,
    private readonly routerStore: Store<RouterStoreStates.RouterState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.noteStore.dispatch(NotesStoreActions.NotesResolverActions.notesRequested({ udid }));
      }),
      map(() => true),
      first()
    );
  }
}
